export const KEY_SITEPAGES_WIDGETS_DATA = 'sitePagesWidgetsData_1'
export const KEY_SITEPAGES_LAYOUT_DATA = 'sitePagesLayoutData_1'
